import React from 'react';

const ScopeButton = (props) => {
  const isDisabled = props.countJob === 0;

  const handleClick = () => {
    if (!isDisabled) {
      props.onSelectScope();
    }
  };

  return (
    <>
      <p
        className={` ${isDisabled ? 'disabled' : ''}`}
        style={{color: isDisabled ? '#979797B3' : 'black', cursor: isDisabled ? 'not-allowed' : 'pointer'}}
        onClick={handleClick}>
        {props.utilTitle}{' '}
        <span
          style={{
            color: isDisabled ? '#979797B3' : 'black',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          }}>
          ({props.countJob})
        </span>
      </p>
    </>
  );
};

export default ScopeButton;
